import { SAVE_LEVEL } from '../../constants/Level';
import ThirdpartyService from '../../services/ThirdpartyService';
import { envValue } from '../../../config/envUtils';
import { httpClient } from '../../../lib/utils';
import { get } from 'lodash';
import store from '../../store/Store';
import * as ActionTypes from '../../constants/ActionTypes';

export function getAndSetInContextBetaForLogin(chainId, hotelId = null, saveLevel = SAVE_LEVEL.CHAIN) {
    const urlParams = ThirdpartyService.paramProxy(chainId, hotelId, null, saveLevel);
    const SOURCEURL = envValue('SOURCEURL');
    const url = `${SOURCEURL}/shs-bedesigner-services/v1/contents/thirdparty?${urlParams}&explicitlevel=${saveLevel}&foldlevel=${SAVE_LEVEL.CHAIN}`

    httpClient.get(url).then(response => {
        const resultCode = get(response, 'data.Result.ResultCode');
        const inContextBeta = get(response, 'data.BEDesignerResult.Value.Explicit.Data.inContextBeta');

        if (resultCode === 'SUCCESS') {
            store.dispatch({ type: ActionTypes.SET_IN_CONTEXT_BETA, inContextBeta });
        }

        return Promise.resolve(inContextBeta);
    });
}


// WEBPACK FOOTER //
// ./src/components/helpers/getAndSetInContextBetaForLogin.js